<template>
  <div class="big">
    <div class="page_title">操作记录</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item
              index="1"
              style="font-size:16px"
            >平台端</el-menu-item>
            <el-menu-item
              index="2"
              style="font-size:16px"
              :disabled="
                  module_id_array[0] ? !module_id_array.includes('190') : false
                "
            >医生端</el-menu-item>
            <el-menu-item
              index="3"
              style="font-size:16px"
              :disabled="
                  module_id_array[0] ? !module_id_array.includes('191') : false
                "
            >患者端</el-menu-item>
            <el-menu-item
              index="4"
              style="font-size:16px"
              :disabled="
                  module_id_array[0] ? !module_id_array.includes('765') : false
                "
            >云药房</el-menu-item>
          </el-menu>
        </div>
        <div class="box">
          <div class="component">
            <keep-alive>
              <component :is="currentComponent" />
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Platform from './Platform.vue';
import Doctor from './Doctor.vue';
import Patient from './Patient.vue';
import Hospital from './Hospital.vue';

export default {
  data() {
    return {
      activeIndex: '1',
      active: '1'
    };
  },
  computed: {
    currentComponent() {
      switch (this.active) {
        case '1':
          return Platform;
        case '2':
          return Doctor;
        case '3':
          return Patient;
        case '4':
          return Hospital;
        default:
          return Platform;
      }
    },
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },

  methods: {
    handleSelect(key) {
      this.active = key;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
